import { API_BASE_URL } from "@/api/api.config";
import useRestQuery from "@/remoteState/useRestQuery";

/**
 * Get classrooms'information about an particular user.
 *
 * @param {(string)} teacherId Id of an particular student.
 * @returns {{data: Object, error: Error, loading: boolean}} Info about the query state.
 */
const useTeacherGet = (teacherId) => {
  const requestUrl = `${API_BASE_URL}/api/v2/teacher/${teacherId}/`;
  return useRestQuery(requestUrl, { skip: !teacherId });
};

export default useTeacherGet;
